/* Timbrica — /eclipse-tracker. Затмения: когда, где и что увидите ВЫ.
 *
 * ПОЧЕМУ ЭТОТ ТУЛ ВООБЩЕ НУЖЕН
 * ----------------------------
 * По запросу «солнечное затмение» (227 117 показов/мес) в выдаче Яндекса нет НИ
 * ОДНОГО инструмента — только новости: «сегодня в 13:40 смотрите в небо». Ни
 * карты полосы, ни ответа на единственный вопрос, который у человека есть:
 * «а у меня-то будет видно и во сколько?»
 *
 * ЧТО МЫ ДЕЛАЕМ ИНАЧЕ
 *   1. ЛОКАЛЬНЫЕ ОБСТОЯТЕЛЬСТВА, а не общая дата: контакты C1–C4 для точки
 *      пользователя с высотой И АЗИМУТОМ Солнца в каждый момент. Сверено с
 *      публикацией: полная фаза в Луксоре 02.08.2027 сходится до 3 секунд.
 *   2. ПОЛОСА КАК ЗОНА. Не только центральная линия, но и её границы: линия
 *      отвечает «где лучше всего», а человек спрашивает «попадаю ли я».
 *   3. КАРТИНКА ХОДА ЗАТМЕНИЯ. Диск Солнца с наползающей Луной, слайдер по
 *      времени от первого до последнего контакта — «на что это будет похоже».
 *   4. ЧЕСТНОЕ «НЕ ВИДНО» + следующее событие, которое ДОЙДЁТ. Новость этого
 *      не делает, а «не видно» получает большинство: солнечное затмение видно
 *      с узкой полосы планеты.
 *   5. БЕЗОПАСНОСТЬ. Смотреть на Солнце без фильтра — ожог сетчатки без боли и
 *      без предупреждения. Предупреждение стоит рядом с временем, а не в
 *      подвале мелким шрифтом.
 *
 * ⚠️ ВРЕМЯ — В ПОЯСЕ ТОЧКИ, А НЕ ПО ДОЛГОТЕ. Здесь стояло
 * `Math.round(lon / 15) * 60`, и замер 14.08.2026 показал: время врало в шести
 * городах из десяти (Париж и Мадрид на 2 часа, Луксор на час — это как раз
 * города затмения 2027). Пояс берётся из базы городов или из вендоренной сетки
 * IANA, летнее время считает сам браузер. Подробности — place-time.js.
 *
 * Вся астрономия — общая (astro-ephemeris.js + astronomy-engine).
 */
(function () {
  'use strict';

  var C = window.ECLIPSE_CFG || {};
  var T = C.t || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
  var stage = function (n) { try { window.__stage && window.__stage(n); } catch (e) {} };

  var AC = window.AstroEphemeris, A = window.Astronomy;
  if (!AC || !A) {
    var h = $('ecList'); if (h) h.innerHTML = '<div class="ec-err">' + tr('engine_failed') + '</div>';
    ae('tool_error', { slug: 'eclipse-tracker', reason: 'astro_core_missing' });
    return;
  }

  var DAY_MS = 86400000;

  var state = {
    place: { lat: C.home.lat, lon: C.home.lon, label: C.home.label || '', tz: null },
    events: [],          // объединённый список солнечных и лунных
    selected: null,
    band: null,          // рассчитанная полоса выбранного солнечного затмения
    map: null, pathLayer: null, meMarker: null, peakMarker: null,
    sim: { t0: null, t1: null, at: null, playing: false, timer: null }
  };

  // ── Время в поясе ТОЧКИ ─────────────────────────────────────────────────────

  var PT = window.__placeTime;

  /** Пояс выбранной точки: у города он известен, иначе — по сетке IANA. */
  function placeZone() {
    if (state.place.tz) return state.place.tz;
    if (PT) return PT.zoneOf(state.place.lat, state.place.lon);
    return null;
  }
  function fmtTime(d) {
    if (!d) return '—';
    if (PT) return PT.format(d, placeZone(), C.locale,
      { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    return d.toISOString().slice(11, 19);
  }
  function fmtShortTime(d) {
    if (!d) return '—';
    if (PT) return PT.format(d, placeZone(), C.locale, { hour: '2-digit', minute: '2-digit' });
    return d.toISOString().slice(11, 16);
  }
  function fmtDate(d) {
    if (!d) return '—';
    if (PT) return PT.format(d, placeZone(), C.locale,
      { day: 'numeric', month: 'long', year: 'numeric' });
    return d.toISOString().slice(0, 10);
  }
  function fmtNum(x, d) {
    try { return Number(x).toLocaleString(C.locale, { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
    catch (e) { return Number(x).toFixed(d || 0); }
  }
  function countdown(ms) {
    var s = Math.max(0, ms / 1000);
    var dd = Math.floor(s / 86400), hh = Math.floor((s % 86400) / 3600), mm = Math.floor((s % 3600) / 60);
    if (dd > 0) return dd + tr('d_short') + ' ' + hh + tr('h_short');
    if (hh > 0) return hh + tr('h_short') + ' ' + mm + tr('m_short');
    return mm + tr('m_short');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function setText(id, v) { var el = $(id); if (el) el.textContent = v; }

  /** Румб по азимуту — «на юго-западе» человеку понятнее, чем «226°». */
  var DIRS = ['dir_n', 'dir_ne', 'dir_e', 'dir_se', 'dir_s', 'dir_sw', 'dir_w', 'dir_nw'];
  function dirOf(az) {
    var i = Math.round(((az % 360) + 360) % 360 / 45) % 8;
    return tr(DIRS[i]);
  }

  // ── Сбор событий ────────────────────────────────────────────────────────────

  var SOLAR_KIND = { partial: 'kind_partial', annular: 'kind_annular', total: 'kind_total', hybrid: 'kind_hybrid' };
  var LUNAR_KIND = { penumbral: 'kind_penumbral', partial: 'kind_lunar_partial', total: 'kind_lunar_total' };

  /**
   * Ближайшие N затмений обоих типов, слитые по времени.
   * Локальные обстоятельства считаются ЛЕНИВО (по клику): SearchLocalSolarEclipse
   * заметно дороже глобального поиска, и считать его сразу для десяти событий
   * значит подвесить страницу на пустом месте.
   */
  function collect(n) {
    var out = [];
    var from = new Date(Date.now() - DAY_MS);      // «сегодня» ещё считается ближайшим

    var s = A.SearchGlobalSolarEclipse(from);
    for (var i = 0; i < n; i++) {
      out.push({ type: 'solar', kind: s.kind, peak: s.peak.date, obscuration: s.obscuration,
        peakLat: s.latitude, peakLon: s.longitude });
      s = A.NextGlobalSolarEclipse(s.peak);
    }
    var l = A.SearchLunarEclipse(from);
    for (var j = 0; j < n; j++) {
      out.push({ type: 'lunar', kind: l.kind, peak: l.peak.date,
        sdPenum: l.sd_penum, sdPartial: l.sd_partial, sdTotal: l.sd_total });
      l = A.NextLunarEclipse(l.peak);
    }
    out.sort(function (a, b) { return a.peak - b.peak; });
    return out.slice(0, n + 4);
  }

  /** Обстоятельства события в точке пользователя. Считается по требованию. */
  function localize(ev) {
    if (ev.local) return ev.local;
    var obs = AC.observer(state.place.lat, state.place.lon, 0);
    if (ev.type === 'solar') {
      var r = null;
      try {
        // Ищем от «за сутки до пика» — так поиск гарантированно попадает в это
        // же затмение, а не проскакивает к следующему.
        r = A.SearchLocalSolarEclipse(new Date(ev.peak.getTime() - DAY_MS), obs);
      } catch (e) { r = null; }
      // Движок мог найти СЛЕДУЮЩЕЕ затмение, если это до нас не доходит.
      if (r && Math.abs(r.peak.time.date - ev.peak) > 12 * 3600000) r = null;

      // ⚠️ Геометрия затмения считается независимо от того, взошло ли Солнце.
      // Для Москвы 12.08.2026 движок отдаёт полный набор контактов, а Солнце в
      // максимуме на −5° — уже за горизонтом. Сказать «у вас будет видно» здесь
      // значит соврать. Поэтому видимость решает ВЫСОТА СОЛНЦА, а не наличие
      // контактов, и мы отдельно различаем «видно целиком» и «видно только часть».
      if (r) {
        var alts = [r.partial_begin, r.total_begin, r.peak, r.total_end, r.partial_end]
          .filter(Boolean).map(function (c) { return c.altitude; });
        var maxAlt = Math.max.apply(null, alts);
        var peakUp = r.peak.altitude > 0;
        ev.local = {
          visible: maxAlt > 0,
          partialOnly: maxAlt > 0 && !peakUp,
          sunAltAtPeak: r.peak.altitude,
          kind: r.kind, obscuration: r.obscuration,
          c1: r.partial_begin, c2: r.total_begin, max: r.peak, c3: r.total_end, c4: r.partial_end
        };
      } else {
        ev.local = { visible: false };
      }
    } else {
      var v = AC.lunarEclipseVisibility(ev.peak, state.place.lat, state.place.lon, 0);
      var cts = AC.lunarEclipseContacts(ev.peak, ev.sdPenum, ev.sdPartial, ev.sdTotal);
      ev.local = { visible: v.visible, altitude: v.altitude, azimuth: v.azimuth, contacts: cts };
    }
    return ev.local;
  }

  function kindLabel(ev) {
    return tr((ev.type === 'solar' ? SOLAR_KIND[ev.kind] : LUNAR_KIND[ev.kind]) || 'kind_partial');
  }

  /**
   * Дешёвая прикидка видимости для СПИСКА.
   *
   * Полный localize() зовёт SearchLocalSolarEclipse — десятки миллисекунд на
   * событие, а список из четырнадцати строк рисуется при каждой смене места.
   * Здесь достаточно ответа «да / край / нет», и он берётся из геометрии в
   * момент пика: где Солнце и Луна относительно друг друга, и над горизонтом
   * ли они. Точное решение всё равно считается при выборе события.
   */
  function quickVisibility(ev) {
    if (ev.quickVis) return ev.quickVis;
    var res;
    try {
      if (ev.type === 'solar') {
        var g = AC.solarDiskGeometry(ev.peak, state.place.lat, state.place.lon, 0);
        var touching = g.separationDeg < (g.sunRadiusDeg + g.moonRadiusDeg);
        // Пик может приходиться на «до восхода», а край затмения — уже на день.
        // Поэтому смотрим и полтора часа в обе стороны от пика.
        var upSomewhere = g.sunAltitude > 0;
        if (!upSomewhere) {
          for (var dt = -90; dt <= 90 && !upSomewhere; dt += 30) {
            if (!dt) continue;
            var g2 = AC.solarDiskGeometry(new Date(ev.peak.getTime() + dt * 60000),
              state.place.lat, state.place.lon, 0);
            if (g2.sunAltitude > 0 && g2.separationDeg < (g2.sunRadiusDeg + g2.moonRadiusDeg)) {
              upSomewhere = true;
            }
          }
        }
        res = !touching || !upSomewhere ? 'no' : (g.sunAltitude > 3 ? 'yes' : 'warn');
      } else {
        var v = AC.lunarEclipseVisibility(ev.peak, state.place.lat, state.place.lon, 0);
        res = v.visible ? (v.altitude > 3 ? 'yes' : 'warn') : 'no';
      }
    } catch (e) { res = 'no'; }
    ev.quickVis = res;
    return res;
  }

  // ── Карта ───────────────────────────────────────────────────────────────────

  function isDark() { return document.documentElement.dataset.theme !== 'light'; }

  /* Палитра карты затмения. Полоса полной фазы — это ВЕСЬ ответ тула, и на
     светлой подложке она обязана быть тёмной, а не «тем же оранжевым».
     Порог контраста к светлой подложке (>3) держит MapBasemapBrightnessTest. */
  var SKIN = {
    dark:  { me: '#7fd1ff', center: '#ff9c4a', peakRim: '#fff',    peakFill: '#ff9c4a', partial: '#ffd68a',
             bandLine: '#ffb870', bandFill: '#ff9c4a', bandOpacity: .75, bandAlpha: .18 },
    light: { me: '#0f5ea8', center: '#b34700', peakRim: '#0b1020', peakFill: '#b34700', partial: '#a8760a',
             bandLine: '#cc6a18', bandFill: '#f08a2c', bandOpacity: .9,  bandAlpha: .3 }
  };
  var skin = document.documentElement.dataset.theme === 'light' ? 'light' : 'dark';

  function ensureMap() {
    if (state.map || typeof L === 'undefined') return state.map;
    var host = $('ecMap');
    /* Отдельная строка, а не #ecMapNote: тот перезаписывается при каждом
       событии (полоса / «лунное видно с половины планеты»), и сообщение о
       недоступной подложке жило бы до первой перерисовки. */
    function showMapOffline() {
      var el = $('ecMapOffline');
      if (!el) return;
      el.textContent = tr('map_offline');
      el.hidden = false;
    }
    if (!host) return null;
    state.map = L.map(host, { worldCopyJump: true, scrollWheelZoom: false, attributionControl: true })
      .setView([state.place.lat, state.place.lon], 2);
    // Подложка — ЧЕРЕЗ ОБЩИЙ ПРИМИТИВ, с запасным адресом и словом при отказе.
    // Здесь стоял `.on('tileerror', function () {})`: крючок был, внутри пусто,
    // и недоступный хост давал чёрный прямоугольник молча.
    var tile = C.tile || {};
    if (window.__mapTiles) {
      window.__mapTiles.base(L, state.map, null, {
        slug: 'eclipse-tracker',
        credit: tr('map_attr'),
        opts: { maxZoom: 10 },
        // Здесь тул сам решал яркость по теме сайта — и решал ПОЛОВИНУ дела:
        // плитки светлели, а полоса полной фазы оставалась бледно-оранжевой
        // (#ff9c4a на positron — контраст 2.0). Замер 23.08: в собственном
        // светлом режиме тул терял 100% пикселей своей графики. Теперь
        // яркостью владеет примитив, и вместе с плитками едет палитра.
        styles: tile.styles, labels: tile.labels,
        onStyle: function (mode) {
          skin = SKIN[mode] ? mode : 'dark';
          var el = document.getElementById('ecMap');
          if (el) el.setAttribute('data-basemap', mode);
          if (typeof drawEvent === 'function' && state.selected) { try { drawEvent(state.selected); } catch (e) {} }
        },
        onExhausted: showMapOffline,
      });
    } else if (window.__basemapFallback) {
      window.__basemapFallback(L, state.map, tr('map_attr'));
    }

    // Клик по карте — выбор места. Эталонные трекеры затмений умеют это, и
    // это единственный способ ответить на вопрос «а если поехать вон туда».
    state.map.on('click', function (e) {
      pickPlace(e.latlng.lat, e.latlng.lng, null, null);
      ae('feature_use', { slug: 'eclipse-tracker', feature: 'map_pick' });
    });
    return state.map;
  }

  function drawEvent(ev) {
    var map = ensureMap();
    if (!map) return;
    if (state.pathLayer) { map.removeLayer(state.pathLayer); state.pathLayer = null; }
    if (state.peakMarker) { map.removeLayer(state.peakMarker); state.peakMarker = null; }
    if (state.meMarker) { map.removeLayer(state.meMarker); state.meMarker = null; }

    state.meMarker = L.circleMarker([state.place.lat, state.place.lon],
      { radius: 6, color: SKIN[skin].me, weight: 2, fillColor: SKIN[skin].me, fillOpacity: .85 })
      .addTo(map).bindPopup(esc(state.place.label || tr('your_place')));

    var box = $('ecMapNote');
    var legend = $('ecMapLegend');
    if (ev.type !== 'solar') {
      // У лунного затмения нет полосы: его видно с ВСЕЙ ночной половины планеты.
      if (box) box.textContent = tr('lunar_no_path');
      if (legend) legend.hidden = true;
      map.setView([state.place.lat, state.place.lon], 2);
      return;
    }

    // Полоса от МЕСТА НЕ ЗАВИСИТ — она про Землю целиком. Считаем её один раз
    // на событие: без кэша каждый клик по карте пересчитывал заново, а это
    // самое дорогое, что тут есть (~60 мс на быстрой машине, кратно больше на
    // телефоне), и всё ради одного и того же результата.
    var band = ev.band || (ev.band = AC.solarEclipseBand(ev.peak, 4));
    state.band = band;
    if (!band.center.length) {
      // Частное затмение: ось тени вообще не касается Земли — полосы не бывает.
      //
      // ⚠️ И ТОЧКИ МАКСИМУМА НА ПОВЕРХНОСТИ ТОЖЕ НЕТ — по той же причине.
      // Здесь стояло `circleMarker([ev.peakLat, ev.peakLon])`, то есть код
      // противоречил строке выше: полосы нет, потому что ось мимо Земли, но
      // точку на Земле мы всё-таки рисовали. astronomy-engine говорит это
      // прямым текстом в своём же исходнике:
      //     let latitude;  // left undefined for partial eclipses
      //     let longitude; // left undefined for partial eclipses
      // Leaflet на таком входе бросает «Invalid LatLng object: (undefined,
      // undefined)» и уносит отрисовку целиком (Sentry G7, Android 13).
      //
      // Правильный ответ — не выдумывать точку: подпись про отсутствие полосы
      // уже сказана, а карта остаётся на месте наблюдателя, которое отмечено
      // выше. Обзорный масштаб потому, что частное видно с огромной области.
      if (box) box.textContent = tr('no_path_partial');
      if (legend) legend.hidden = true;
      map.setView([state.place.lat, state.place.lon], 2);
      return;
    }
    if (legend) legend.hidden = false;
    if (box) {
      box.textContent = tr('path_note') +
        (band.widthKm ? ' ' + tr('band_width') + ': ' + fmtNum(band.widthKm, 0) + ' ' + tr('km') + '.' : '') +
        ' ' + tr('pick_on_map');
    }

    var layers = [];
    // Заливка полосы: границы «туда» и «обратно» дают замкнутый контур зоны,
    // где затмение полное. Без заливки человек мерит расстояние до ЛИНИИ и
    // считает, что промахнулся, стоя внутри полосы.
    // На светлой подложке тот же оранжевый на 18 % прозрачности почти исчезает,
    // поэтому заливка и обводка там плотнее и темнее.
    var light = skin === 'light';
    if (band.north.length > 2 && band.south.length > 2) {
      splitByAntimeridian(band.north).forEach(function (nSeg, i) {
        var sSeg = splitByAntimeridian(band.south)[i];
        if (!sSeg || sSeg.length < 2 || nSeg.length < 2) return;
        var ring = nSeg.concat(sSeg.slice().reverse());
        layers.push(L.polygon(ring, {
          color: SKIN[skin].bandLine, weight: 1, opacity: SKIN[skin].bandOpacity,
          dashArray: '4 4', fillColor: SKIN[skin].bandFill,
          fillOpacity: SKIN[skin].bandAlpha
        }));
      });
    }
    splitByAntimeridian(band.center).forEach(function (seg) {
      if (seg.length > 1) layers.push(L.polyline(seg, { color: SKIN[skin].center, weight: 3, opacity: .95 }));
    });
    state.pathLayer = L.layerGroup(layers).addTo(map);

    state.peakMarker = L.circleMarker([ev.peakLat, ev.peakLon],
      { radius: 6, color: SKIN[skin].peakRim, weight: 2, fillColor: SKIN[skin].peakFill, fillOpacity: 1 })
      .addTo(map).bindPopup(tr('greatest_eclipse'));
    try {
      var b = L.latLngBounds(band.center.map(function (p) { return [p.lat, p.lon]; }));
      map.fitBounds(b.extend([state.place.lat, state.place.lon]), { padding: [24, 24] });
    } catch (e) { map.setView([ev.peakLat, ev.peakLon], 2); }
  }

  /* Режем линию там, где она перескакивает антимеридиан, иначе Leaflet
     протянет её через весь мир поперёк карты. */
  function splitByAntimeridian(pts) {
    var segs = [[]], prev = null;
    pts.forEach(function (p) {
      if (prev && Math.abs(p.lon - prev.lon) > 180) segs.push([]);
      segs[segs.length - 1].push([p.lat, p.lon]);
      prev = p;
    });
    return segs.filter(function (s) { return s.length > 1; });
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371, toR = Math.PI / 180;
    var dLa = (lat2 - lat1) * toR, dLo = (lon2 - lon1) * toR;
    var x = Math.sin(dLa / 2) * Math.sin(dLa / 2) +
      Math.cos(lat1 * toR) * Math.cos(lat2 * toR) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(x)));
  }

  /** Расстояние до центральной линии, км — «попадаю ли я» в цифрах. */
  function distanceToPath(band) {
    if (!band || !band.center.length) return null;
    var best = Infinity;
    band.center.forEach(function (p) {
      best = Math.min(best, haversineKm(state.place.lat, state.place.lon, p.lat, p.lon));
    });
    return best;
  }

  // ── Города на полосе ────────────────────────────────────────────────────────

  /**
   * «Куда поехать, чтобы увидеть полную фазу» — вопрос, который идёт следом за
   * «у меня не видно», а ответить на него негде: новости называют страны, а
   * человеку нужен город и время в нём.
   *
   * База городов весит около трёх мегабайт, поэтому грузим её ТОЛЬКО по явному
   * нажатию: кто не спрашивал, за это не платит трафиком.
   */
  function citiesOnBand(band, limit) {
    var LI = window.LocationInput;
    var data = LI && LI.getData && LI.getData();
    if (!data || !data.index || !band || band.center.length < 2) return null;

    // Полуширина полосы своя в каждой точке — у краёв прохода тень косая и
    // пятно вытянуто, там полоса заметно шире, чем в точке максимума.
    var half = band.center.map(function (c, i) {
      var n = band.north[i];
      return n ? haversineKm(c.lat, c.lon, n.lat, n.lon) : 130;
    });
    var latMin = 90, latMax = -90, lonMin = 180, lonMax = -180;
    band.center.forEach(function (p) {
      latMin = Math.min(latMin, p.lat); latMax = Math.max(latMax, p.lat);
      lonMin = Math.min(lonMin, p.lon); lonMax = Math.max(lonMax, p.lon);
    });
    var pad = 4;
    var crossesDateline = (lonMax - lonMin) > 180;

    var out = [];
    var idx = data.index;
    for (var i = 0; i < idx.length; i++) {
      var row = idx[i];
      var lat = row[0], lon = row[1], pop = row[5] || 0;
      if (pop < 50000) continue;                       // иначе список из посёлков
      if (lat < latMin - pad || lat > latMax + pad) continue;
      if (!crossesDateline && (lon < lonMin - pad || lon > lonMax + pad)) continue;
      var best = Infinity, bestJ = -1;
      for (var j = 0; j < band.center.length; j++) {
        var c = band.center[j];
        // Дешёвая отсечка до дорогой формулы: разница широт уже больше полосы.
        if (Math.abs(c.lat - lat) > 4) continue;
        var d = haversineKm(lat, lon, c.lat, c.lon);
        if (d < best) { best = d; bestJ = j; }
      }
      if (bestJ < 0 || best > half[bestJ]) continue;   // вне полосы
      out.push({ index: i, lat: lat, lon: lon, pop: pop, dist: best, at: band.center[bestJ].date });
    }
    out.sort(function (a, b) { return b.pop - a.pop; });
    return out.slice(0, limit || 8).map(function (c) {
      var full = LI.rowToCity ? LI.rowToCity(c.index) : null;
      c.name = (full && full.name) || '';
      c.cc = full && full.cc;
      c.tz = full && full.tz;
      return c;
    });
  }

  /** Длительность полной фазы в городе — то, ради чего туда и едут. */
  function totalityAt(ev, lat, lon) {
    try {
      var r = A.SearchLocalSolarEclipse(new Date(ev.peak.getTime() - DAY_MS),
        AC.observer(lat, lon, 0));
      if (!r || !r.total_begin || !r.total_end) return null;
      if (Math.abs(r.peak.time.date - ev.peak) > 12 * 3600000) return null;
      return {
        seconds: (r.total_end.time.date - r.total_begin.time.date) / 1000,
        peak: r.peak.time.date,
        altitude: r.peak.altitude
      };
    } catch (e) { return null; }
  }

  function renderCities(ev) {
    var box = $('ecCities');
    var btn = $('ecCitiesBtn');
    if (!box || !btn) return;
    // Десять, а не восемь: сортировка идёт по населению, и на затмении 2027
    // восьмёрка обрывалась ровно перед Луксором — местом с самой долгой полной
    // фазой на суше, ради которого туда и едут.
    // Список городов, как и полоса, привязан к СОБЫТИЮ, а не к месту зрителя —
    // перебирать 34 тысячи городов на каждый клик по карте незачем.
    // Кандидатов берём с запасом: часть отсеется на следующем шаге, а список
    // должен остаться полным.
    var cand = ev.cities || (ev.cities = citiesOnBand(state.band, 16));
    // ⚠️ Город БЕЗ полной фазы в списке «города на полосе» — это прочерк на
    // экране и вопрос «а он тут зачем». Такое бывает у самой границы, где моя
    // геометрия и поиск локальных обстоятельств расходятся на километры;
    // прав движок, поэтому такие города просто не показываем.
    var list = (cand || []).filter(function (c) {
      if (c.totality === undefined) c.totality = totalityAt(ev, c.lat, c.lon);
      return !!c.totality;
    }).slice(0, 10);
    if (!list.length) {
      box.innerHTML = '<p class="ec-none">' + esc(tr('cities_none')) + '</p>';
      return;
    }
    var html = '';
    list.forEach(function (c) {
      var t = c.totality;
      // «0 мин 47 с» — так никто не говорит; меньше минуты пишем секундами.
      var dur = t.seconds < 60
        ? fmtNum(Math.round(t.seconds), 0) + ' ' + tr('sec')
        : fmtNum(Math.floor(t.seconds / 60), 0) + ' ' + tr('min') + ' ' +
          fmtNum(Math.round(t.seconds % 60), 0) + ' ' + tr('sec');
      var when = t && window.__placeTime
        ? window.__placeTime.format(t.peak, c.tz || null, C.locale, { hour: '2-digit', minute: '2-digit' })
        : '';
      html += '<button type="button" class="ec-city" data-lat="' + c.lat + '" data-lon="' + c.lon +
        '" data-tz="' + esc(c.tz || '') + '" data-name="' + esc(c.name) + '">' +
        '<span class="ec-city-n">' + esc(c.name) + (c.cc ? ' <span class="ec-city-cc">' + esc(c.cc) + '</span>' : '') + '</span>' +
        '<span class="ec-city-d">' + esc(dur) + '</span>' +
        '<span class="ec-city-t">' + esc(when) + '</span></button>';
    });
    box.innerHTML = html;
    [].slice.call(box.querySelectorAll('.ec-city')).forEach(function (b) {
      b.addEventListener('click', function () {
        pickPlace(Number(b.dataset.lat), Number(b.dataset.lon), b.dataset.name, b.dataset.tz || null);
        ae('feature_use', { slug: 'eclipse-tracker', feature: 'pick_city_on_band' });
      });
    });
  }

  function loadCities(ev) {
    var btn = $('ecCitiesBtn'), box = $('ecCities');
    if (!btn || !box) return;
    var LI = window.LocationInput;
    if (!LI || !LI.loadData) { box.innerHTML = '<p class="ec-none">' + esc(tr('cities_none')) + '</p>'; return; }
    btn.disabled = true;
    box.hidden = false;
    box.innerHTML = '<p class="ec-none">' + esc(tr('cities_loading')) + '</p>';
    LI.loadData().then(function () {
      btn.hidden = true;
      renderCities(ev);
    }, function () {
      btn.disabled = false;
      box.innerHTML = '<p class="ec-none">' + esc(tr('city_load_error')) + '</p>';
    });
    ae('feature_use', { slug: 'eclipse-tracker', feature: 'cities_on_band' });
  }

  // ── Симуляция вида ──────────────────────────────────────────────────────────

  /**
   * Диски рисуются по РАЗНИЦЕ ВЫСОТ И АЗИМУТОВ, а не по позиционному углу:
   * так картинка совпадает с тем, что человек видит, подняв голову, — Луна
   * наползает с той же стороны. Позиционный угол дал бы вид «как в атласе»,
   * повёрнутый на параллактический угол, то есть до 90° мимо.
   *
   * Вправо на картинке = рост азимута: стоя лицом к северу, восток справа;
   * лицом к югу — запад справа. Это верно для любого направления взгляда.
   */
  function simGeometry(ev, when) {
    if (ev.type === 'solar') {
      var g = AC.solarDiskGeometry(when, state.place.lat, state.place.lon, 0);
      var dAz = ((g.moonAzimuth - g.sunAzimuth + 540) % 360) - 180;
      return {
        kind: 'solar',
        mainR: g.sunRadiusDeg,
        overR: g.moonRadiusDeg,
        dx: dAz * Math.cos(g.sunAltitude * Math.PI / 180),
        dy: g.moonAltitude - g.sunAltitude,
        altitude: g.sunAltitude,
        azimuth: g.sunAzimuth,
        obscuration: AC.obscurationFrom(g.sunRadiusDeg, g.moonRadiusDeg, g.separationDeg),
        magnitude: g.magnitude
      };
    }
    var s = AC.lunarShadowGeometry(when, state.place.lat, state.place.lon, 0);
    var dAz2 = ((s.moonAzimuth - s.shadowAzimuth + 540) % 360) - 180;
    return {
      kind: 'lunar',
      mainR: s.umbraRadiusDeg,
      penR: s.penumbraRadiusDeg,
      overR: s.moonRadiusDeg,
      dx: dAz2 * Math.cos(s.shadowAltitude * Math.PI / 180),
      dy: s.moonAltitude - s.shadowAltitude,
      altitude: s.moonAltitude,
      azimuth: s.moonAzimuth,
      obscuration: AC.obscurationFrom(s.moonRadiusDeg, s.umbraRadiusDeg,
        Math.hypot(dAz2 * Math.cos(s.shadowAltitude * Math.PI / 180),
          s.moonAltitude - s.shadowAltitude))
    };
  }

  function drawSim(ev, when) {
    var cv = $('ecSim');
    if (!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var W = cv.width, H = cv.height, cx = W / 2, cy = H / 2;
    ctx.clearRect(0, 0, W, H);

    var g;
    try { g = simGeometry(ev, when); } catch (e) { g = null; }
    if (!g) { setText('ecSimObsc', tr('sim_no_data')); return; }

    // Масштаб кадра. У солнечного он привязан к диску Солнца — тот всегда в
    // центре. У лунного нельзя брать полутень: она втрое шире умбры, и Луна
    // на её фоне превращалась в точку в 25 пикселей — картинка переставала
    // читаться как «Луна входит в тень». Кадр берём по тому, что реально
    // происходит: тень плюс запас на диаметр Луны в любом её положении.
    var sepNow = Math.hypot(g.dx, g.dy);
    var frameDeg = g.kind === 'solar'
      ? g.mainR * 4.2
      : Math.max(g.mainR, sepNow) + 2.2 * g.overR;
    var k = (W / 2) / frameDeg;
    var px = function (d) { return d * k; };

    if (g.kind === 'solar') {
      var R = px(g.mainR);
      // Корона видна только когда диск закрыт почти целиком — рисовать её
      // всегда значит показывать полное затмение там, где его нет.
      if (g.obscuration > 0.985) {
        var cor = ctx.createRadialGradient(cx, cy, R * 0.98, cx, cy, R * 2.6);
        cor.addColorStop(0, 'rgba(255,238,200,.55)');
        cor.addColorStop(0.35, 'rgba(255,220,160,.18)');
        cor.addColorStop(1, 'rgba(255,210,140,0)');
        ctx.fillStyle = cor;
        ctx.beginPath(); ctx.arc(cx, cy, R * 2.6, 0, 6.284); ctx.fill();
      } else {
        var glow = ctx.createRadialGradient(cx, cy, R * 0.9, cx, cy, R * 1.7);
        glow.addColorStop(0, 'rgba(255,206,110,.35)');
        glow.addColorStop(1, 'rgba(255,206,110,0)');
        ctx.fillStyle = glow;
        ctx.beginPath(); ctx.arc(cx, cy, R * 1.7, 0, 6.284); ctx.fill();
      }
      var sun = ctx.createRadialGradient(cx - R * .2, cy - R * .2, R * .1, cx, cy, R);
      sun.addColorStop(0, '#fff6d8'); sun.addColorStop(.7, '#ffd166'); sun.addColorStop(1, '#f9a825');
      ctx.fillStyle = sun;
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.284); ctx.fill();

      // Луна: непрозрачный диск. Никакого «затемнения по альфе» — Луна не
      // полупрозрачная, и полутон здесь читался бы как частичное закрытие.
      ctx.fillStyle = '#0c101c';
      ctx.beginPath();
      ctx.arc(cx + px(g.dx), cy - px(g.dy), px(g.overR), 0, 6.284);
      ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,.16)'; ctx.lineWidth = Math.max(1, W / 400);
      ctx.stroke();
    } else {
      var PR = px(g.penR), UR = px(g.mainR);
      // Полутень рисуется от края умбры наружу и обычно выходит за кадр —
      // так и надо: важен её КРАЙ у Луны, а не полный круг.
      var pen = ctx.createRadialGradient(cx, cy, UR, cx, cy, Math.max(PR, UR * 1.05));
      pen.addColorStop(0, 'rgba(24,18,26,.78)');
      pen.addColorStop(1, 'rgba(40,40,60,.06)');
      ctx.fillStyle = pen;
      ctx.beginPath(); ctx.arc(cx, cy, Math.max(PR, UR * 1.05), 0, 6.284); ctx.fill();
      ctx.fillStyle = 'rgba(42,14,14,.94)';
      ctx.beginPath(); ctx.arc(cx, cy, UR, 0, 6.284); ctx.fill();
      ctx.strokeStyle = 'rgba(190,90,70,.5)'; ctx.lineWidth = Math.max(1, W / 300);
      ctx.beginPath(); ctx.arc(cx, cy, UR, 0, 6.284); ctx.stroke();

      var mx = cx + px(g.dx), my = cy - px(g.dy), mr = px(g.overR);
      var moon = ctx.createRadialGradient(mx - mr * .25, my - mr * .25, mr * .1, mx, my, mr);
      moon.addColorStop(0, '#fdfaf3'); moon.addColorStop(1, '#cfc7b8');
      ctx.fillStyle = moon;
      ctx.beginPath(); ctx.arc(mx, my, mr, 0, 6.284); ctx.fill();

      ctx.save();
      ctx.beginPath(); ctx.arc(mx, my, mr, 0, 6.284); ctx.clip();
      // Полутень гасит Луну заметно, но плавно: полутеневое затмение — это
      // «луна потускнела», и если не показать этого вовсе, картинка такого
      // затмения ничем не отличается от обычного полнолуния.
      var penShade = ctx.createRadialGradient(cx, cy, UR, cx, cy, Math.max(PR, UR * 1.05));
      penShade.addColorStop(0, 'rgba(60,40,40,.55)');
      penShade.addColorStop(1, 'rgba(80,70,80,0)');
      ctx.fillStyle = penShade;
      ctx.beginPath(); ctx.arc(cx, cy, Math.max(PR, UR * 1.05), 0, 6.284); ctx.fill();
      // Часть Луны внутри умбры — медно-красная: именно так её видно глазом,
      // и именно это делает «кровавую луну» кровавой.
      ctx.fillStyle = 'rgba(150,52,30,.88)';
      ctx.beginPath(); ctx.arc(cx, cy, UR, 0, 6.284); ctx.fill();
      ctx.restore();
    }

    // Горизонт — только когда светило низко: иначе линия внизу кадра ничего не
    // сообщает, а место занимает.
    if (g.altitude < 12) {
      var hy = cy + px(g.altitude) + (H * 0.0);
      if (hy > 0 && hy < H) {
        ctx.strokeStyle = 'rgba(255,255,255,.35)';
        ctx.setLineDash([W / 60, W / 60]); ctx.lineWidth = Math.max(1, W / 320);
        ctx.beginPath(); ctx.moveTo(0, hy); ctx.lineTo(W, hy); ctx.stroke();
        ctx.setLineDash([]);
        ctx.fillStyle = 'rgba(10,14,24,.55)';
        ctx.fillRect(0, hy, W, H - hy);
        ctx.fillStyle = 'rgba(255,255,255,.5)';
        ctx.font = (W / 26) + 'px system-ui, sans-serif';
        ctx.textAlign = C.dir === 'rtl' ? 'right' : 'left';
        ctx.fillText(tr('horizon'), C.dir === 'rtl' ? W - W / 40 : W / 40, hy - W / 60);
      }
    }

    setText('ecSimTime', fmtTime(when));
    var parts = [fmtNum(g.obscuration * 100, 0) + '% ' + tr('obscured')];
    if (g.altitude <= 0) parts = [tr('sim_below_horizon')];
    setText('ecSimObsc', parts.join(' · '));
  }

  /** Диапазон времени для слайдера: от первого до последнего контакта. */
  function simRange(ev) {
    var loc = localize(ev);
    if (ev.type === 'solar' && loc.c1 && loc.c4) {
      return [loc.c1.time.date, loc.c4.time.date];
    }
    if (ev.type === 'lunar' && loc.contacts && loc.contacts.p1) {
      return [loc.contacts.p1, loc.contacts.p4];
    }
    // Затмение до нас не доходит — показываем ход по МИРУ вокруг пика, чтобы
    // картинка не была пустой: человеку всё равно интересно, как это выглядит
    // там, где видно.
    var half = ev.type === 'solar' ? 100 * 60000 : (ev.sdPenum || 120) * 60000;
    return [new Date(ev.peak.getTime() - half), new Date(ev.peak.getTime() + half)];
  }

  function setupSim(ev) {
    var r = simRange(ev);
    state.sim.t0 = r[0]; state.sim.t1 = r[1];
    stopPlay();
    var rng = $('ecSimRange');
    // Стартуем с максимума: это кадр, ради которого человек пришёл.
    // ⚠️ Максимум берём МЕСТНЫЙ, а не ev.peak: тот относится к точке
    // наибольшего затмения на планете и в Москве отстоял от местного
    // максимума на 27 минут — ползунок вставал мимо самого зрелища.
    var loc = localize(ev);
    var peakLocal = (ev.type === 'solar' && loc.max && loc.max.time)
      ? loc.max.time.date : ev.peak;
    var atMax = (peakLocal - r[0]) / (r[1] - r[0]);
    atMax = Math.max(0, Math.min(1, atMax));
    if (rng) rng.value = String(Math.round(atMax * 1000));
    setText('ecSimStart', fmtShortTime(r[0]));
    setText('ecSimEnd', fmtShortTime(r[1]));
    setText('ecSimNote', tr('sim_hint'));
    simAt(atMax);
  }

  function simAt(frac) {
    if (!state.selected || !state.sim.t0) return;
    var t = new Date(state.sim.t0.getTime() + (state.sim.t1 - state.sim.t0) * frac);
    state.sim.at = t;
    drawSim(state.selected, t);
  }

  function stopPlay() {
    state.sim.playing = false;
    if (state.sim.timer) { clearInterval(state.sim.timer); state.sim.timer = null; }
    var icon = $('ecSimIcon'), btn = $('ecSimPlay');
    if (icon) icon.innerHTML = '<path d="M8 5v14l11-7z"/>';
    if (btn) btn.setAttribute('aria-label', tr('sim_play'));
  }

  function togglePlay() {
    if (state.sim.playing) { stopPlay(); return; }
    var rng = $('ecSimRange');
    if (!rng) return;
    if (Number(rng.value) >= 1000) rng.value = '0';
    state.sim.playing = true;
    var icon = $('ecSimIcon'), btn = $('ecSimPlay');
    if (icon) icon.innerHTML = '<path d="M6 5h4v14H6zM14 5h4v14h-4z"/>';
    if (btn) btn.setAttribute('aria-label', tr('sim_pause'));
    // 40 мс — плавно и при этом с запасом: сама геометрия считается за ~1.5 мс
    // на быстрой машине, а шаг по времени задаётся кадром, а не таймером.
    state.sim.timer = setInterval(function () {
      var v = Number(rng.value) + 8;
      if (v >= 1000) { v = 1000; stopPlay(); }
      rng.value = String(v);
      simAt(v / 1000);
    }, 40);
    ae('feature_use', { slug: 'eclipse-tracker', feature: 'sim_play' });
  }

  // ── Отрисовка ───────────────────────────────────────────────────────────────

  function renderHero(ev) {
    var loc = localize(ev);
    setText('ecHeroKind', kindLabel(ev));
    setText('ecHeroDate', fmtDate(ev.peak));
    // ⚠️ Прошедшее событие нельзя подписывать «Начнётся через 0мин» — так
    // выглядело затмение 12.08.2026 на следующий день после него. Для прошлого
    // меняем и подпись, и число: «Прошло 1 д 4 ч».
    var past = ev.peak.getTime() < Date.now();
    setText('ecHeroCdLabel', past ? tr('passed_ago') : tr('starts_in'));
    setText('ecHeroCd', countdown(Math.abs(ev.peak - Date.now())));

    var v = $('ecHeroVis');
    if (v) {
      if (ev.type === 'solar') {
        if (!loc.visible) {
          v.textContent = tr('not_visible_here');
          v.className = 'ec-vis no';
        } else if (loc.partialOnly) {
          // Солнце садится посреди затмения — говорим об этом прямо.
          v.textContent = tr('visible_partly');
          v.className = 'ec-vis warn';
        } else {
          v.textContent = tr('visible_here') + ' — ' + fmtNum((loc.obscuration || 0) * 100, 0) + '% ' + tr('obscured');
          v.className = 'ec-vis yes';
        }
      } else {
        v.textContent = loc.visible ? tr('visible_here') : tr('moon_below');
        v.className = 'ec-vis ' + (loc.visible ? 'yes' : 'no');
      }
    }
    // Предупреждение о глазах — только там, где на Солнце реально смотрят.
    var warn = $('ecSafety');
    if (warn) warn.hidden = !(ev.type === 'solar' && loc.visible);

    renderNextVisible(ev);
  }

  /**
   * «А какое ближайшее видно У МЕНЯ» — следующий шаг для большинства.
   * Показываем только когда выбранное не видно: иначе кнопка предлагала бы
   * уйти с того, что человек и так получил.
   */
  function renderNextVisible(ev) {
    var btn = $('ecNextVisible');
    if (!btn) return;
    var loc = ev.local || {};
    if (loc.visible) { btn.hidden = true; return; }

    var next = null;
    for (var i = 0; i < state.events.length; i++) {
      var e = state.events[i];
      if (e === ev || e.peak.getTime() < Date.now()) continue;
      if (quickVisibility(e) !== 'no') { next = e; break; }
    }
    if (!next) {
      btn.hidden = true;
      return;
    }
    setText('ecNextVisibleText', tr('next_visible_cta') + ': ' + kindLabel(next) + ', ' + fmtDate(next.peak));
    btn.hidden = false;
    btn.onclick = function () {
      select(next);
      ae('feature_use', { slug: 'eclipse-tracker', feature: 'next_visible' });
    };
  }

  function renderLocal(ev) {
    var loc = localize(ev);
    var box = $('ecLocal');
    if (!box) return;

    if (ev.type === 'lunar') {
      var c = loc.contacts || {};
      var html = '';
      if (c.p1) html += row(tr('p1'), fmtTime(c.p1));
      if (c.u1) html += row(tr('u1'), fmtTime(c.u1));
      if (c.u2) html += row(tr('u2'), fmtTime(c.u2));
      html += row(tr('lunar_peak'), fmtTime(ev.peak), true);
      if (c.u3) html += row(tr('u3'), fmtTime(c.u3));
      if (c.u4) html += row(tr('u4'), fmtTime(c.u4));
      if (c.p4) html += row(tr('p4'), fmtTime(c.p4));
      html += row(tr('moon_altitude'), loc.altitude == null ? '—'
        : fmtNum(loc.altitude, 0) + '° <span class="ec-alt">' + esc(dirOf(loc.azimuth || 0)) + '</span>');
      if (ev.sdTotal) html += row(tr('total_dur'), fmtNum(ev.sdTotal * 2, 0) + ' ' + tr('min'));
      else if (ev.sdPartial) html += row(tr('partial_dur'), fmtNum(ev.sdPartial * 2, 0) + ' ' + tr('min'));
      else if (ev.sdPenum) html += row(tr('penumbral_dur'), fmtNum(ev.sdPenum * 2, 0) + ' ' + tr('min'));
      box.innerHTML = html;
      return;
    }
    if (!loc.visible) {
      var extra = '';
      if (state.band) {
        var d = distanceToPath(state.band);
        if (d != null && isFinite(d)) {
          extra = '<div class="ec-kv"><span>' + esc(tr('distance_to_path')) + '</span><b>' +
            fmtNum(d, 0) + ' ' + esc(tr('km')) + '</b></div>';
        }
      }
      box.innerHTML = '<p class="ec-none">' + esc(tr('not_visible_long')) + '</p>' + extra;
      return;
    }

    // Высота И азимут: «Солнце на 12°» не говорит, куда встать. Низкое
    // затмение без открытого горизонта в нужную сторону просто не увидеть.
    var at = function (c) {
      if (!c || !c.time) return '—';
      var s = fmtTime(c.time.date);
      if (c.altitude != null) {
        var az = null;
        try { az = AC.solarDiskGeometry(c.time.date, state.place.lat, state.place.lon, 0).sunAzimuth; }
        catch (e) {}
        s += ' <span class="ec-alt">☉ ' + fmtNum(c.altitude, 0) + '°' +
          (az != null ? ' ' + esc(dirOf(az)) : '') + '</span>';
      }
      return s;
    };
    var out = row(tr('c1'), at(loc.c1));
    if (loc.c2) out += row(tr('c2'), at(loc.c2));
    out += row(tr('max'), at(loc.max), true);
    if (loc.c3) out += row(tr('c3'), at(loc.c3));
    out += row(tr('c4'), at(loc.c4));
    if (loc.c2 && loc.c3) {
      var dur = (loc.c3.time.date - loc.c2.time.date) / 1000;
      out += row(tr('totality_dur'), fmtNum(Math.floor(dur / 60), 0) + ' ' + tr('min') + ' ' +
        fmtNum(Math.round(dur % 60), 0) + ' ' + tr('sec'));
    }
    out += row(tr('obscuration'), fmtNum((loc.obscuration || 0) * 100, 1) + '%');
    // Магнитуда — то, что печатают справочники; путать её с закрытой площадью
    // нельзя, поэтому обе строки стоят рядом.
    try {
      var gm = AC.solarDiskGeometry(loc.max.time.date, state.place.lat, state.place.lon, 0);
      out += row(tr('magnitude'), fmtNum(gm.magnitude, 3));
    } catch (e) {}
    if (state.band) {
      var dp = distanceToPath(state.band);
      if (dp != null && isFinite(dp)) {
        var inside = state.band.widthKm && dp < state.band.widthKm / 2;
        out += row(tr('distance_to_path'), inside
          ? esc(tr('inside_path'))
          : fmtNum(dp, 0) + ' ' + esc(tr('km')));
      }
    }
    box.innerHTML = out;
  }

  function row(k, v, hi) {
    return '<div class="ec-kv' + (hi ? ' hi' : '') + '"><span>' + esc(k) + '</span><b>' + v + '</b></div>';
  }

  function renderList() {
    var box = $('ecList');
    if (!box) return;
    box.innerHTML = '';
    var VIS_LABEL = { yes: 'vis_yes_short', warn: 'vis_partial_short', no: 'vis_no_short' };
    state.events.forEach(function (ev) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ec-row' + (state.selected === ev ? ' sel' : '');
      var icon = ev.type === 'solar' ? '☉' : '☾';
      var vis = quickVisibility(ev);
      // Пометка видимости — цветом И подписью: цвет один не читается людьми с
      // дальтонизмом, а таких у нас отдельная аудитория.
      btn.innerHTML = '<span class="ec-row-i">' + icon + '</span>' +
        '<span class="ec-row-v ' + vis + '" title="' + esc(tr(VIS_LABEL[vis])) + '"></span>' +
        '<span class="ec-row-n">' + esc(kindLabel(ev)) + '</span>' +
        '<span class="ec-row-d">' + esc(fmtDate(ev.peak)) + '</span>' +
        '<span class="ec-row-z">' + esc(countdown(ev.peak - Date.now())) + '</span>';
      btn.setAttribute('aria-label', kindLabel(ev) + ', ' + fmtDate(ev.peak) + ' — ' + tr(VIS_LABEL[vis]));
      btn.addEventListener('click', function () {
        select(ev);
        ae('feature_use', { slug: 'eclipse-tracker', feature: 'pick_event' });
      });
      box.appendChild(btn);
    });
  }

  // ── Календарь и ссылка ──────────────────────────────────────────────────────

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function icsStamp(d) {
    return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate()) + 'T' +
      pad(d.getUTCHours()) + pad(d.getUTCMinutes()) + pad(d.getUTCSeconds()) + 'Z';
  }
  function icsEsc(s) {
    return String(s).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,')
      .replace(/\r?\n/g, '\\n');
  }

  /**
   * Событие в календарь. Границы берём по КОНТАКТАМ, а не «час вокруг пика»:
   * затмение идёт два-три часа, и напоминание на момент максимума приходит,
   * когда половина зрелища уже позади.
   */
  function addToCalendar() {
    var ev = state.selected;
    if (!ev) return;
    var loc = localize(ev);
    var start = ev.peak, end = new Date(ev.peak.getTime() + 3600000);
    if (ev.type === 'solar' && loc.c1 && loc.c4) {
      start = loc.c1.time.date; end = loc.c4.time.date;
    } else if (ev.type === 'lunar' && loc.contacts && loc.contacts.p1) {
      start = loc.contacts.p1; end = loc.contacts.p4;
    }
    var title = (ev.type === 'solar' ? tr('cal_title_solar') : tr('cal_title_lunar'))
      .replace(':kind', kindLabel(ev));
    var where = state.place.label || (fmtNum(state.place.lat, 2) + ', ' + fmtNum(state.place.lon, 2));
    var desc = tr('cal_desc').replace(':place', where).replace(':url', shareUrl());

    var lines = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Timbrica//eclipse-tracker//EN',
      'CALSCALE:GREGORIAN', 'BEGIN:VEVENT',
      'UID:eclipse-' + ev.peak.getTime() + '-' + ev.type + '@timbrica',
      'DTSTAMP:' + icsStamp(new Date()),
      'DTSTART:' + icsStamp(start),
      'DTEND:' + icsStamp(end),
      'SUMMARY:' + icsEsc(title),
      'DESCRIPTION:' + icsEsc(desc),
      'LOCATION:' + icsEsc(where),
      'BEGIN:VALARM', 'TRIGGER:-PT1H', 'ACTION:DISPLAY',
      'DESCRIPTION:' + icsEsc(title), 'END:VALARM',
      'END:VEVENT', 'END:VCALENDAR'
    ];
    var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
    var name = 'eclipse-' + ev.peak.toISOString().slice(0, 10) + '.ics';
    if (window.__downloadFile) window.__downloadFile(blob, name);
    ae('feature_use', { slug: 'eclipse-tracker', feature: 'calendar' });
  }

  /** Ссылка на КОНКРЕТНОЕ событие и место — иначе поделиться нечем. */
  function shareUrl() {
    var ev = state.selected;
    var base = location.origin + location.pathname;
    if (!ev) return base;
    var q = 'e=' + ev.peak.toISOString().slice(0, 10) +
      '&lat=' + state.place.lat.toFixed(3) + '&lon=' + state.place.lon.toFixed(3);
    if (state.place.label) q += '&p=' + encodeURIComponent(state.place.label);
    return base + '#' + q;
  }

  function shareLink() {
    var url = shareUrl();
    try { history.replaceState(null, '', url); } catch (e) {}
    var done = function () {
      if (window.__toast) window.__toast(tr('link_copied'), 'success');
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () {
        if (window.__toast) window.__toast(tr('copy_failed'), 'warning');
      });
    } else if (window.__toast) {
      window.__toast(tr('copy_failed'), 'warning');
    }
    ae('feature_use', { slug: 'eclipse-tracker', feature: 'share' });
  }

  /** Разбор ссылки: дата события + место. Обе части необязательны. */
  function readHash() {
    var raw = (location.hash || '').replace(/^#/, '');
    if (!raw) return null;
    var out = {}, ok = false;
    raw.split('&').forEach(function (kv) {
      var i = kv.indexOf('='); if (i < 0) return;
      var k = kv.slice(0, i), v = decodeURIComponent(kv.slice(i + 1));
      if (k === 'e' && /^\d{4}-\d{2}-\d{2}$/.test(v)) { out.date = v; ok = true; }
      if (k === 'lat') { out.lat = parseFloat(v); }
      if (k === 'lon') { out.lon = parseFloat(v); }
      if (k === 'p') { out.label = v.slice(0, 80); }
    });
    if (out.lat != null && !isNaN(out.lat) && out.lon != null && !isNaN(out.lon)) ok = true;
    return ok ? out : null;
  }

  // ── Место ───────────────────────────────────────────────────────────────────

  /**
   * Подпись пояса. ⚠️ Три РАЗНЫХ случая, и путать их нельзя: подпись «время
   * местное для выбранной точки» над временем устройства — ровно та ложь,
   * ради устранения которой этот модуль и появился. Если сетка поясов не
   * приехала, честнее сказать, чьё это время на самом деле.
   */
  function showZone() {
    var el = $('ecTz');
    if (!el) return;
    if (!PT) { el.textContent = tr('tz_utc'); return; }
    var tz = placeZone();
    var when = state.selected ? state.selected.peak : new Date();
    if (!tz) { el.textContent = tr('tz_device').replace(':zone', PT.label(null, when, C.locale)); return; }
    el.textContent = tr('tz_note').replace(':zone', PT.label(tz, when, C.locale));
  }

  function pickPlace(lat, lon, label, tz) {
    state.place = {
      lat: lat, lon: lon,
      label: label || '',
      tz: tz || null
    };
    if (!label) namePlace(state.place);
    rebuild(true);
  }

  /**
   * Подпись точки, выбранной на карте или геолокацией, — общий модуль GeoCity
   * (public/js/geo-city.js): город с именем на языке страницы ближе 150 км,
   * иначе страна. Прежде брался ближайший город базы как есть — латиницей на
   * русской странице и за тысячу километров от клика посреди океана; там
   * подписи нет, и страница говорит координатами.
   */
  function namePlace(place) {
    if (!window.GeoCity) return;
    GeoCity.lookup(place.lat, place.lon, { mode: 'near' }).then(function (it) {
      var s = GeoCity.text(it);
      if (!s || state.place !== place || place.label) return;
      place.label = s;
      if (state.meMarker) state.meMarker.setPopupContent(esc(s));
    });
  }

  function mountLocationInput() {
    var host = $('ecLocInput');
    if (!host || !window.LocationInput) return;
    window.LocationInput.mount(host, {
      tool: 'eclipse-tracker',
      t: T,
      initial: { lat: state.place.lat, lng: state.place.lon, cityName: state.place.label, tz: state.place.tz },
      onChange: function (loc) {
        if (loc.lat == null || loc.lng == null) return;
        state.place = {
          lat: loc.lat, lon: loc.lng,
          label: loc.cityName || '',
          // Геолокация приходит БЕЗ пояса — берём его по координатам, а не
          // по браузеру: человек может смотреть на точку в другой стране.
          tz: loc.tz || null
        };
        if (!state.place.label) namePlace(state.place);
        rebuild(true);
        ae('feature_use', { slug: 'eclipse-tracker', feature: 'place_' + (loc.source || 'set') });
      }
    });
  }

  // ── Сборка ──────────────────────────────────────────────────────────────────

  /* Ответ выдан — на экране конкретное затмение с вердиктом «видно / не видно
     отсюда». Один раз за страницу: дальше человек листает список, и это
     feature_use. Вердикт кладём в событие — это главный вопрос тула, и без
     него мы не увидим, скольким мы отвечаем «не видно» (а таких большинство,
     и им нужен другой следующий шаг). */
  var answered = false;
  function markAnswered(ev) {
    if (answered || !ev) return;
    answered = true;
    // ⚠️ ОТЛОЖЕННО, и это не мелочь: первая отрисовка случается ВНУТРИ boot(),
    // до stage('ready'), поэтому прямой вызов давал порядок
    // load -> complete -> ready. Воронка, где ответ выдан раньше готовности,
    // не просто выглядит странно — в ней бессмысленны все задержки dwell_ms.
    setTimeout(function () { stage('complete'); }, 0);
    ae('tool_complete', {
      slug: 'eclipse-tracker',
      kind: ev.type,
      // Поле называется `visible` (булево), не `visibility` — сверено по коду,
      // а не по памяти: выдуманное имя ушло бы в базу как 'unknown' у всех.
      visible: !!(ev.local && ev.local.visible),
      days_ahead: Math.round((ev.peak.getTime() - Date.now()) / 86400000),
    });
  }

  function select(ev) {
    state.selected = ev;
    state.band = null;
    renderHero(ev);
    drawEvent(ev);          // считает полосу — от неё зависит «до полосы» ниже
    renderLocal(ev);
    renderList();
    setupSim(ev);
    showZone();
    syncCitiesBlock(ev);
    markAnswered(ev);
  }

  /**
   * Блок «города на полосе» есть только там, где полоса есть: у лунного
   * затмения и у частного, чья тень проходит мимо Земли, предлагать «куда
   * поехать» бессмысленно.
   */
  function syncCitiesBlock(ev) {
    var wrap = $('ecCitiesWrap'), btn = $('ecCitiesBtn'), box = $('ecCities');
    if (!wrap || !btn || !box) return;
    var hasBand = ev.type === 'solar' && state.band && state.band.center.length > 1;
    wrap.hidden = !hasBand;
    if (!hasBand) return;
    box.innerHTML = '';
    var LI = window.LocationInput;
    // База уже загружена (человек искал город) — показываем сразу, без кнопки:
    // платить за неё второй раз не нужно.
    if (LI && LI.getData && LI.getData()) {
      btn.hidden = true;
      box.hidden = false;
      renderCities(ev);
    } else {
      btn.hidden = false;
      btn.disabled = false;
      box.hidden = true;
    }
  }

  function rebuild(keepSelection) {
    var wantedPeak = keepSelection && state.selected ? state.selected.peak.getTime() : null;
    // Сами затмения от места НЕ ЗАВИСЯТ: искать их заново при каждом клике по
    // карте — это два десятка глобальных поисков впустую. Пересчитываем только
    // то, что действительно привязано к точке: видимость и обстоятельства.
    if (!state.events.length) state.events = collect(10);
    state.events.forEach(function (e) { e.local = null; e.quickVis = null; });
    var next = null;
    if (wantedPeak) {
      next = state.events.filter(function (e) {
        return Math.abs(e.peak.getTime() - wantedPeak) < DAY_MS;
      })[0];
    }
    if (!next) {
      // Показываем БУДУЩЕЕ событие: прошедшие остаются в списке как контекст,
      // но герой страницы не должен предлагать то, что уже случилось.
      var now = Date.now();
      next = state.events.filter(function (e) { return e.peak.getTime() >= now; })[0] || state.events[0];
    }
    if (next) select(next);
  }

  function applyHash() {
    var h = readHash();
    if (!h) return false;
    if (h.lat != null && h.lon != null && Math.abs(h.lat) <= 90 && Math.abs(h.lon) <= 180) {
      state.place = { lat: h.lat, lon: h.lon, label: h.label || '', tz: null };
    }
    state.events = collect(10);
    if (h.date) {
      var target = state.events.filter(function (e) {
        return e.peak.toISOString().slice(0, 10) === h.date;
      })[0];
      if (target) { select(target); return true; }
    }
    return false;
  }

  function boot() {
    stage('load');
    var opened = false;
    try { opened = applyHash(); } catch (e) { opened = false; }
    mountLocationInput();
    if (!opened) rebuild(false);

    var rng = $('ecSimRange');
    if (rng) {
      rng.addEventListener('input', function () {
        stopPlay();
        simAt(Number(rng.value) / 1000);
      });
    }
    var play = $('ecSimPlay');
    if (play) play.addEventListener('click', togglePlay);
    var cal = $('ecCal');
    if (cal) cal.addEventListener('click', addToCalendar);
    var sh = $('ecShare');
    if (sh) sh.addEventListener('click', shareLink);
    var cb = $('ecCitiesBtn');
    if (cb) cb.addEventListener('click', function () {
      if (state.selected) loadCities(state.selected);
    });

    stage('ready');
    setInterval(function () {
      if (state.selected) setText('ecHeroCd', countdown(Math.abs(state.selected.peak - Date.now())));
    }, 30000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
